import prebidService from './prebidService';
import pubsub from '../utils/pubsub';
import perf from '../utils/performance';
import conditionalService from '../services/conditionalService';

let config,
	maxIterations;

pubsub.subscribe('extendSlots', _extendSlots);

async function init(cfg) {
	perf.mark('prebid - initialisation');
	config = await _readConfig(cfg);

	if (Object.keys(cfg ?? {}).length === 0) {
		config = null;
	}

	if (config) {
		config = conditionalService.applyConditionalConfiguration(config);
	}

	perf.mark('prebid - initialisation - end');
}

function _readConfig(cfg) {
	if (cfg?.caching) {
		return new Promise((resolve) => {
			_waitForHeaderBiddingConfig(cfg.caching, 1, resolve);
		});
	}

	return cfg;
}

async function _waitForHeaderBiddingConfig(cachingConfig, iteration, resolve) {
	const cfg = await cachingConfig.getConfig();

	if (cfg) {
		resolve(cfg);

		return;
	}

	if (iteration >= cachingConfig.maxIterations) {
		console.warn(`[ADVERT] Header bidding is skipped after trying fetching ${maxIterations} times.`);

		resolve(null);

		return;
	}

	setTimeout(() => _waitForHeaderBiddingConfig(cachingConfig, ++iteration, resolve), iteration * 100);
}

function _extendSlots(slots) {
	if (config) {
		return prebidService.getBids(config, slots).catch((err) => {
			console.error('[ADVERT] Something went wrong getting prebid bids.', err);
		});
	}
}

export default {
	init
};
